// ---------------------------------------------------------------------------
// Signed numbers in localStorage.
//
// Be clear about what this is worth: the secret is in the bundle, so anyone
// willing to read the source can forge a value. It stops the thirty-second
// attack — open devtools, set guilders to a million — and nothing more. A
// number that actually mattered would have to live on the server.
//
// A value that does not check out is treated as absent rather than trusted or
// mourned: reset to zero and rewritten, so a tampered hold is simply an empty
// one next time the page opens.
// ---------------------------------------------------------------------------

const SALT = 'zaanse-schans:herring:v1';

/** djb2. Not a cryptographic hash, and not pretending to be. */
function sign(value) {
    const text = `${value}|${SALT}`;
    let h = 5381;
    for (let i = 0; i < text.length; i++) h = ((h << 5) + h + text.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
}

/** @returns the stored number, or 0 if missing, corrupt or tampered with. */
export function readNumber(key, { max = 9_999_999 } = {}) {
    let raw;
    try {
        raw = localStorage.getItem(key);
    } catch {
        return 0;   // storage disabled; nothing to read and nothing to fix
    }
    if (!raw) return 0;

    let parsed;
    try {
        parsed = JSON.parse(raw);
    } catch {
        writeNumber(key, 0);
        return 0;
    }

    const n = Number(parsed?.v);
    if (!Number.isFinite(n) || n < 0 || n > max || parsed?.s !== sign(parsed.v)) {
        writeNumber(key, 0);
        return 0;
    }
    return Math.floor(n);
}

export function writeNumber(key, value) {
    const v = Math.max(0, Math.floor(value) || 0);
    try {
        localStorage.setItem(key, JSON.stringify({ v, s: sign(v) }));
    } catch { /* nothing worth breaking for */ }
}
